// Components
import { Button } from '@tracklib/kit'

// Hooks
import { useSubscription } from 'modules/subscription/hooks'

import styles from './deleteaccountform.css'

const DeleteAccountForm = () => {
  const subscription = useSubscription()
  const tier = subscription?.tier
  const planCancelled = tier && !subscription.next_renewal_period

  return (
    <div className={styles.wrapper}>
      <h2>Delete account</h2>
      <p>
        If you don&apos;t want to use Tracklib anymore you can{' '}
        <Button
          className={styles.button}
          modal
          to={!tier || planCancelled ? 'deleteaccount' : 'deleteorcancel'}
          variant="transparent"
          datatesting="link_delete_account"
        >
          click here to delete your account.
        </Button>
      </p>
    </div>
  )
}

export default DeleteAccountForm
